import Env from '../../base/env'
import gsap from 'gsap'
import SplitText  from "../../vendor/gsap-bonus/SplitText";
gsap.registerPlugin(SplitText);

export default class WineWords
{
  constructor(view)
  {
    this.view = view
    this.$title = this.view.querySelector('.jsTitle')
    this.$desc = this.view.querySelector('.jsDesc')
    this.instanceTxt = new SplitText(this.$desc , { type:"lines" })
    this.animate()
  }

  animate()
  {
    const shuffle = Env.framework.toolbox.shuffled(this.instanceTxt.lines)
    gsap.fromTo(
      this.$title,
      { autoAlpha : 0},
      { autoAlpha : 1, ease: 'cubic.inOut', duration: 1.2 , delay : .2 },
    )
    gsap.fromTo(
      shuffle,
      { autoAlpha : 0},
      { autoAlpha : 1, ease: 'cubic.inOut', duration: 1.2, stagger: .25 , delay : .5 },
    )
  }
}
